
export default class SelectParam {
    constructor(el) {
        this.el = el;
        this.initEvents();
    }

    initEvents() {
        this.el.addEventListener("click", (e) => {
            e.preventDefault();
            this.handleChange();
        });
    }

    handleChange() {
        var param = this.el.value;
        console.log("param", param);

        var key = param.split("=")[0];
        var value = param.split("=")[1];

        let url = new URL(window.location);
        var params = new URLSearchParams(url.search);
        params.delete(key);
        params.delete("p");
        if(value !== "") {
            params.append(key, value);
        }

        window.history.pushState(null, '', `${url.pathname}?${params.toString()}`);
    }
}